import { Grid } from '@material-ui/core'
import styled from 'styled-components/macro'

export const Container = styled(Grid)`
    /* .MuiGrid-item {
        padding: 0px 8px 6.5px 0px !important;
    } */

    .MuiFormHelperText-root {
        position: inherit !important;
        top: 0 !important;
    }

    .address_number {
        .MuiFormHelperText-root {
            white-space: nowrap;
        }
    }
`

export const CustomTitle = styled.div`
    display: flex;
    align-items: flex-start;
    margin: 18px 8px 14px 8px;
    width: 100%;
    font-weight: 600;
`
